import { useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";

import AddLeadTag from "@/modules/lead-page/components/lead-info/lead-tags/add-lead-tag";

export const AddTagsAction = () => {
  const [addTagsModalOpen, setAddTagsModalOpen] = useState(false);
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: theme.nawy.spacing.xs,
          padding: theme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor: theme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={() => setAddTagsModalOpen(true)}
      >
        <Typography
          sx={{
            color: theme.nawy.colors.semantic.text.primary,
            ...theme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Add Tags
        </Typography>
      </Box>

      <AddLeadTag open={addTagsModalOpen} setOpen={setAddTagsModalOpen} />
    </>
  );
};
